import React from "react";
import { Form, Input, Button, Select, Switch, Space, Card } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { getBodegas } from "../../../services/bodegas";
import { useEffect, useState } from "react";

const { Option } = Select;
const { TextArea } = Input;

const FormBuilder = ({ form, loading, onFinish }) => {
  const [bodegas, setBodegas] = useState([]);
  const userRole = useSelector((state) => state.userdata.role?.name);
  const userBodegaId = useSelector((state) => state.userdata.bodega?.id);
  const isAdmin = userRole === "adminapp" || userRole === "Administrator";

  useEffect(() => {
    if (isAdmin) {
      const fetchBodegas = async () => {
        try {
          const bodegasData = await getBodegas();
          setBodegas(bodegasData);
        } catch (error) {
          console.error("Error fetching bodegas:", error);
        }
      };
      fetchBodegas();
    }
  }, [isAdmin]);

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item
        name="nombre"
        label="Nombre del Formulario"
        rules={[
          {
            required: true,
            message: "Por favor ingrese el nombre del formulario",
          },
        ]}
      >
        <Input placeholder="Ingrese el nombre del formulario" />
      </Form.Item>

      <Form.Item
        name="descripcion"
        label="Descripción"
        rules={[
          { required: true, message: "Por favor ingrese una descripción" },
        ]}
      >
        <TextArea
          rows={4}
          placeholder="Ingrese la descripción del formulario"
        />
      </Form.Item>

      {isAdmin && (
        <Form.Item
          name="bodega"
          label="Bodega"
          rules={[
            { required: true, message: "Por favor seleccione una bodega" },
          ]}
        >
          <Select placeholder="Seleccione una bodega">
            {bodegas.map((bodega) => (
              <Option key={bodega.id} value={bodega.id}>
                {bodega.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.List name="campos" >
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Card
                key={key}
                style={{ marginBottom: 16 }}
                extra={<MinusCircleOutlined onClick={() => remove(name)} />}
              >
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Form.Item
                    {...restField}
                    name={[name, "label"]}
                    label="Etiqueta del Campo"
                    rules={[
                      {
                        required: true,
                        message: "Ingrese la etiqueta del campo",
                      },
                    ]}
                  >
                    <Input placeholder="Ej: Nombre, Edad, etc." />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, "tipo"]}
                    label="Tipo de Campo"
                    rules={[
                      {
                        required: true,
                        message: "Seleccione el tipo de campo",
                      },
                    ]}
                  >
                    <Select placeholder="Seleccione el tipo de campo">
                      <Option value="texto">Texto</Option>
                      <Option value="numero">Número</Option>
                      <Option value="select">Select</Option>
                      <Option value="multiple_unico">Selección Única</Option>
                      <Option value="multiple_multiple">
                        Selección Múltiple
                      </Option>
                      <Option value="fecha">Fecha</Option>
                      <Option value="imagen">Imagen</Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return (
                        prevValues.campos?.[name]?.tipo !==
                        currentValues.campos?.[name]?.tipo
                      );
                    }}
                  >
                    {({ getFieldValue }) => {
                      const tipo = getFieldValue(["campos", name, "tipo"]);

                      if (
                        [
                          "select",
                          "multiple_unico",
                          "multiple_multiple",
                        ].includes(tipo)
                      ) {
                        return (
                          <Form.Item
                            {...restField}
                            name={[name, "opciones"]}
                            label="Opciones (separadas por comas)"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Ingrese las opciones separadas por comas",
                              },
                            ]}
                          >
                            <Input placeholder="Ej: Opción 1, Opción 2, Opción 3" />
                          </Form.Item>
                        );
                      }

                      if (tipo === "imagen") {
                        return (
                          <Space direction="vertical" style={{ width: "100%" }}>
                            <Form.Item
                              {...restField}
                              name={[name, "camara"]}
                              label="Cámara"
                              valuePropName="checked"
                            >
                              <Switch />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "galeria"]}
                              label="Galería"
                              valuePropName="checked"
                            >
                              <Switch />
                            </Form.Item>
                          </Space>
                        );
                      }

                      return null;
                    }}
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, "requerido"]}
                    label="Campo Requerido"
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "visible_app"]}
                    label="Visible en la app?"
                    valuePropName="checked"
                  >
                    <Switch defaultChecked />
                  </Form.Item>
                </Space>
              </Card>
            ))}

            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Agregar Campo
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Crear Formulario
        </Button>
      </Form.Item>
    </Form>
  );
};

export default FormBuilder;
